import { Link, useNavigate } from "react-router-dom";
import Headline4 from "../../../compopnents/headings/Headline4";
import Styles from "./styles.module.scss";
import AuthHead from "../AuthHead";
import AuthMedia from "../authMedia";
import { LoginForm } from "./loginForm";
import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { getCustomerForUserId } from "./services";
import mixpanelData, { viewedpageMixpanel } from "../../../utils/mixpanel";
import { checkSize } from "../../../utils/ellowutils";



Auth.configure({
  userPoolId: "ap-south-1_RFCGvpA7m",
  userPoolWebClientId: "3mbs8c16e6jc3g0l7iq56obak0", // app client id
  //identityPoolId: "42efbd0d-8bcb-46a2-b028-0a8affe3bb63",
  region: "ap-south-1",
  oauth: {
    region: "ap-south-1",
    domain: "https://ellow-prod-customer.auth.ap-south-1.amazoncognito.com",
    scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
    redirectSignIn: "https://mytalent-ellow.io/dashboard",
    redirectSignOut: "https://mytalent-ellow.io/customerlogin",
    responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
  }
})

function Login() {
  
  const navigate = useNavigate();
  const[message, setMessage] = useState<string>()
  const[disabled, setDisabled] = useState<boolean>(false)

  useEffect(() => {
    viewedpageMixpanel();
   },[]);

  const onSubmit = (data: any) => {
  setDisabled(true)
  setMessage('')
  const custom = {roleid:'1'}
    Auth.signIn(data.email, data.password, custom)
      .then(async (result: any) => { 
        const session = await Auth.currentSession();
        const accessToken = session.getIdToken().getJwtToken();   
        const refreshToken = session.getRefreshToken().getToken();
        console.log('accessToken', accessToken);  
        localStorage.setItem('Token', accessToken)
        localStorage.setItem('refreshToken', refreshToken)
        getCustomerForUserId(result.attributes.sub).then((response) => {
          if (response && response.status === 1) {
            localStorage.setItem('loginId', result.attributes.sub)
            localStorage.setItem('Email', result.attributes.email)
            localStorage.setItem('customerId', response.data[0].customer_id)
            localStorage.setItem('customerMetdata',JSON.stringify(response.data[0].customer_metadata))
            navigate('/dashboard')
            mixpanelData('MT - Customer login', {
              'source': 'Customer login successfully',
              'distinct_id': result.attributes.email,
              'companyName': response && response.data && response.data.customer_metadata && response.data.customer_metadata.companyName,
              'work email': response && response.data && response.data.customer_metadata && response.data.customer_metadata.workEmail,
              'Phone Number': response && response.data && response.data.customer_metadata && response.data.customer_metadata.phoneNumber,
              'Skills': response && response.data && response.data.customer_metadata && response.data.customer_metadata.skills && response.data.customer_metadata.skills.toString(),
              'First Name': response && response.data && response.data.customer_metadata && response.data.customer_metadata.firstName,
              'Company Size': response && response.data && response.data.customer_metadata && response.data.customer_metadata.size && checkSize(response.data.customer_metadata.size)?.name,
              'company Website': response && response.data && response.data.customer_metadata && response.data.customer_metadata.website,
              'Work with remote' : response && response.data && response.data.customer_metadata && response.data.customer_metadata.workWithRemote === 0 ? 'Yes' : 'No',
            })
            mixpanelData('New MT - Login', {
              'distinct_id': result.attributes.email,
              'Email': result.attributes.email
            })
          }
        })
       
      })
      .catch(err => {
        mixpanelData('MT - Customer login', {
          'source': 'Customer login failed'
        })
        setDisabled(false)
        setMessage(err.message)
      });
  };

  return (
    <section className="App">
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          <AuthHead />
          <div className={Styles.alignCenter}>
            <aside className={Styles.loginSignupWapper}>
              <div className={Styles.head}><Headline4>Welcome to ellow.io!</Headline4></div>
               <p className={Styles.or}>Sign in with your account</p>
              <div className={Styles.loginWith}>
                <LoginForm ClickHandler={onSubmit} disabled={disabled}/>
                <div>
                  <p className="error-message">{message}</p>
                </div>
                <div className={Styles.alreadyRegistered}>Don’t have an ellow account? <Link to="/">Sign up</Link></div>
              </div>
            </aside>
          </div>
        </div>
        <AuthMedia />
      </div>
    </section>
  );
}

export default Login;
